// 等待页面完全渲染
window.addEventListener('load', function() {
    // 检查是否存在FAQ容器，避免全局报错
    if (!document.querySelector('.fanxi-faq-container')) return;

    // 初始化折叠功能
    function initAccordions() {
        const headers = document.querySelectorAll('.fanxi-accordion-header');
        headers.forEach(header => {
            // 强制移除旧事件（Ella模板可能重复绑定）
            const newHeader = header.cloneNode(true);
            header.parentNode.replaceChild(newHeader, header);

            newHeader.addEventListener('click', function() {
                const targetId = this.getAttribute('data-target');
                const content = document.getElementById(targetId);
                if (!content) return;

                // 切换激活状态
                this.classList.toggle('active');
                content.classList.toggle('active');

                // 切换图标
                const icon = this.querySelector('i');
                if (icon) {
                    if (this.classList.contains('active')) {
                        icon.classList.remove('fa-plus');
                        icon.classList.add('fa-minus');
                    } else {
                        icon.classList.remove('fa-minus');
                        icon.classList.add('fa-plus');
                    }
                }
            });
        });
    }

    // 初始化标签页
    function initTabs() {
        const tabs = document.querySelectorAll('.fanxi-tab-header');
        tabs.forEach(tab => {
            const newTab = tab.cloneNode(true);
            tab.parentNode.replaceChild(newTab, tab);

            newTab.addEventListener('click', function() {
                const tabId = this.getAttribute('data-tab');
                const tabContent = document.getElementById(tabId);
                const tabsContainer = this.closest('.fanxi-tabs');
                if (!tabContent || !tabsContainer) return;

                tabsContainer.querySelectorAll('.fanxi-tab-header').forEach(t => t.classList.remove('active'));
                tabsContainer.querySelectorAll('.fanxi-tab-content').forEach(c => c.classList.remove('active'));
                
                this.classList.add('active');
                tabContent.classList.add('active');
            });
        });
    }

    // 执行初始化（延迟100ms确保Ella模板渲染完成）
    setTimeout(() => {
        initAccordions();
        initTabs();
    }, 100);
});